import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow--right",
  "use": "icon-arrow--right-usage",
  "viewBox": "0 0 9 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 9 11\" id=\"icon-arrow--right\"><path d=\"M0 10.775h3.62l4.527-5.388L3.62 0H0l4.526 5.387L0 10.775Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol